export default "__VITE_ASSET__CIbg$Qn7__"